// extracted by mini-css-extract-plugin
export default {"animatedBackground":"_38zhX","placeHolderShimmer":"_1AWJ6","card":"_3XjGX","title":"_2JwoY","content":"_3WtLd"};